import React from "react";
import styles from "../InverluxApps.module.css";

const storeListing = {
  published: false,
  url: "https://chromewebstore.google.com/detail/tab-group-share/hbcanejhohlomoighfiddnmabdnliobn",
};

const TabGroupShareStoreButton = () => {
  const content = (
    <>
      <span className={styles.storeButtonIcon} aria-hidden="true">
        {storeListing.published ? "↗" : "…"}
      </span>
      <span>
        <span className={styles.storeButtonLabel}>
          {storeListing.published ? "Add to Chrome" : "Coming soon"}
        </span>
        <span className={styles.storeButtonStatus}>Chrome Web Store</span>
      </span>
    </>
  );

  if (storeListing.published) {
    return (
      <a
        className={styles.storeButton}
        href={storeListing.url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Add Tab Group Share to Chrome"
      >
        {content}
      </a>
    );
  }

  return (
    <button
      className={`${styles.storeButton} ${styles.storeButtonPending}`}
      type="button"
      disabled
      aria-label="Tab Group Share is coming soon to the Chrome Web Store"
    >
      {content}
    </button>
  );
};

export default TabGroupShareStoreButton;
